module.exports = function ($, M, m, _) {
  'use strict';

  function LeaderboardRow(data) {
    this.photo = m.prop(data.photo);
    this.username = m.prop(data.username);
    this.position = m.prop(data.position);
    this.points = m.prop(data.points);
    this.id = m.prop(data.uid);
    this.following = m.prop(data.following);
    this.hovering = m.prop(false);
  }

  function renderLeaderboardRows(ctrl) {
    return m(
      'ul.leaderboard-rows',
      ctrl.vm.rows().map(function (row, index) {
        var isMyRow = row.id() === M.user.id,
          rowCls = isMyRow ? 'leaderboard-row current' : 'leaderboard-row',
          pointsCls =
            index === 0 && !isMyRow ? 'row-points best' : 'row-points';

        return m('li', { key: row.id(), class: rowCls }, [
          m('span.row-pic', [
            ctrl.vm.largeBoard() ? m('strong', row.position() + '.') : '',
            m('img', { src: row.photo() }),
          ]),
          m('span.row-username', [
            ctrl.vm.largeBoard() ? '' : m('strong', row.position() + '.'),
            m(
              'span',
              {
                'data-role': 'hovercard',
                'data-user-id': row.id(),
                'data-direction': 'right',
              },
              m(
                `a[href=/user/${row.username()}].clickable`,
                row.username(),
              ),
            ),
            ctrl.vm.showFollow() ? renderFollowBtn(ctrl, row) : [],
          ]),
          m('span', { class: pointsCls }, [
            m('span', Handlebars.helpers['intcomma'](row.points())),
          ]),
        ]);
      }),
    );
  }

  function renderFollowBtn(ctrl, row) {
    if (row.id() === M.user.id) return [];

    var following = m(
      'a',
      {
        onclick: _.partial(ctrl.toggleFollow, row),
        onmouseenter: function () {
          row.hovering(true);
        },
        onmouseout: function () {
          row.hovering(false);
        },
      },
      row.hovering() ? _t('unfollow?') : _t('following'),
    );

    var notFollowing = m(
      'a',
      { onclick: _.partial(ctrl.toggleFollow, row) },
      _t('follow'),
    );

    return [row.following() ? following : notFollowing];
  }

  function renderLeaderboardControls(ctrl) {
    return m(
      '.leaderboard-controls',
      m('ul.btn-group', [
        m(
          'li.btn.btn-small' +
            (ctrl.vm.period() === 'week' ? '.active' : ''),
          { onclick: _.partial(ctrl.setPeriod, 'week').bind(ctrl) },
          _t('Week'),
        ),
        m(
          'li.btn.btn-small' +
            (ctrl.vm.period() === 'month' ? '.active' : ''),
          { onclick: _.partial(ctrl.setPeriod, 'month').bind(ctrl) },
          _t('Month'),
        ),
        m(
          'li.btn.btn-small' +
            (ctrl.vm.period() === 'alltime' ? '.active' : ''),
          { onclick: _.partial(ctrl.setPeriod, 'alltime').bind(ctrl) },
          _t('All Time'),
        ),
      ]),
    );
  }

  function renderLoadMore(ctrl) {
    if (
      ctrl.vm.rows().length === 0 ||
      ctrl.vm.rows().length % ctrl.vm.howMany() !== 0 ||
      ctrl.vm.hasPageSet()
    )
      return [];

    return m('.leaderboard-link', [
      m(
        'a',
        {
          onclick: function () {
            ctrl.fetchRows();
          },
        },
        _t('More'),
      ),
    ]);
  }

  M.newLeaderboard = function (opts) {
    var leaderboard = {
      vm: {
        fullBoardUrl: m.prop(opts.fullBoardUrl),
        howMany: m.prop(opts.howMany || 10),
        showTabs: m.prop(opts.showTabs),
        showFollow: m.prop(opts.showFollow),
        period: m.prop('week'),
        largeBoard: m.prop(opts.large),
        offset: m.prop(0),
        rows: m.prop([]),
        hasPageSet: m.prop(window.location.href.indexOf('?page=') > -1),
      },
    };

    leaderboard.controller = function () {
      var ctrl = {
        vm: leaderboard.vm,
        fetchRows: function () {
          var vm = this.vm;
          var offset = vm.rows().length;
          var howMany = vm.howMany();
          var hasPageSet = vm.hasPageSet();

          var existingRows = vm.rows();

          // If we have rows and the last one is the current user
          // and the position of the user is greater than the number of rows
          // user has been injected
          var lastRow = existingRows[existingRows.length - 1];
          var userInjected =
            lastRow &&
            lastRow.id() === M.user.id &&
            lastRow.position() > existingRows.length;

          if (userInjected) {
            // pop user from end
            var me = existingRows.pop();
            // cover the row we have just popped
            offset = offset - 1;
            // if we are going to be returned in next fetch then return 1 more to cover injection
            if (me && me.position() < existingRows.length + vm.howMany())
              howMany = howMany + 1;
          }

          var query = sprintf(
            '?period=%s&how_many=%d',
            vm.period(),
            howMany,
          );
          if (hasPageSet) {
            var page = parseInt(
              window.location.href.match(/page=([0-9])/)[1],
            );
            if (page > 0) offset = page * howMany - howMany;
          }

          if (offset !== 0) {
            query += sprintf('&offset=%d', offset);
          }

          m.request({
            method: 'GET',
            url: opts.endPoint + query,
            unwrapSuccess: function (response) {
              return response.rows;
            },
            type: LeaderboardRow,
          }).then(function (rows) {
            var href = window.location.pathname + '?page=';
            var ctrl_offset = offset + 1;
            var ctrl_howMany = howMany - 1;

            if (ctrl_offset > ctrl_howMany) {
              var prevPage =
                parseInt((ctrl_offset - ctrl_howMany) / ctrl_howMany) + 1;
              var link_prev = $('head').find('link[rel="prev"]');

              if (link_prev.length > 0) {
                link_prev.attr('href', href + prevPage);
              } else {
                $('head').append(
                  $('<link>')
                    .attr('rel', 'prev')
                    .attr('href', href + prevPage),
                );
              }
            }

            if (
              !(vm.rows().length === 0) ||
              !(vm.rows().length % ctrl.vm.howMany() !== 0)
            ) {
              var nextPage =
                parseInt((ctrl_offset + ctrl_howMany) / ctrl_howMany) + 1;
              var link_next = $('head').find('link[rel="next"]');

              if (link_next.length > 0) {
                link_next.attr('href', href + nextPage);
              } else {
                $('head').append(
                  $('<link>')
                    .attr('rel', 'next')
                    .attr('href', href + nextPage),
                );
              }
            }

            if (offset === 0) {
              return vm.rows(rows);
            }

            // user position is greater than all rows loaded
            if (
              userInjected &&
              me.position() > existingRows.length + rows.length
            )
              rows.push(me);
            // else will have been returned in rows
            vm.rows(existingRows.concat(rows));
          });
        },
        toggleFollow: function (row) {
          m.post({
            url: '/ajax/mempal_add/',
            data: { to_user_id: row.id() },
          }).then(
            function () {
              row.following(!row.following());
            },
            function (data) {
              M.modal.error(data.error);
            },
          );
        },
        setPeriod: function (period) {
          this.vm.period(period);
          this.vm.rows([]);
          this.fetchRows();
        },
      };

      ctrl.fetchRows(0);
      return ctrl;
    };

    leaderboard.view = function (ctrl) {
      return m('.leaderboard', [
        m('.leaderboard-header', [
          m('span.leaderboard-image'),
          m('span.leaderboard-text', _t('Leaderboard')),
        ]),

        ctrl.vm.showTabs() ? renderLeaderboardControls(ctrl) : [],

        m('.leaderboard-content', [
          renderLeaderboardRows(ctrl),
          ctrl.vm.largeBoard()
            ? renderLoadMore(ctrl)
            : m('.leaderboard-link', [
                m('a', { href: ctrl.vm.fullBoardUrl() }, _t('More')),
              ]),
        ]),
      ]);
    };

    return leaderboard;
  };
};
